import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'lib-global-file-manager-toolbar',
  templateUrl: './global-file-manager-toolbar.component.html',
  styleUrls: ['./file-manager-toolbar.component.scss']
})
export class GlobalFileManagerToolbarComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}


